'use client';

import { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import {
  Drawer,
  Portal,
  useDrawer,
  DrawerHeader,
  DrawerBody
} from 'components/pcc-components';
import {
  CatHeading,
  CatButton,
  CatIconWarningTriangle,
  CatIconWarningTriangleFilled
} from 'components/blocks-components';
import { ROOT_PORTALS } from 'constants/targets';
import FitmentContent from 'components/fitment-content';
import styles from './unable-to-verify-mobile-drawer.module.scss';
import cx from 'classnames';

export interface UnableToVerifyMobileDrawerProps {
  buttonTitle: ReactNode;
  drawerMessage: string;
  drawerText: string;
  isFitmentMobile: boolean;
}

export default function UnableToVerifyMobileDrawer({
  buttonTitle,
  drawerMessage,
  drawerText,
  isFitmentMobile
}: Readonly<UnableToVerifyMobileDrawerProps>) {
  const t = useTranslations();
  const { drawerProps, openDrawer, closeDrawer, isDrawerOpen } = useDrawer();

  return (
    <>
      <CatButton
        variant="ghost"
        className={styles['unable-to-verify-mobile-drawer__btn']}
        onClick={openDrawer}
      >
        <FitmentContent
          icon={
            isFitmentMobile
              ? CatIconWarningTriangleFilled
              : CatIconWarningTriangle
          }
          iconColor={'warning'}
          buttonTitle={buttonTitle}
          isFitmentMobile={isFitmentMobile}
        />
      </CatButton>
      <Portal id={ROOT_PORTALS}>
        {isDrawerOpen && (
          <Drawer
            {...drawerProps}
            className={styles['unable-to-verify-mobile-drawer']}
            data-testId="unable-to-verify-mobile-drawer"
            onBlDrawerClose={closeDrawer}
            hasBackdrop
            orientation="bottom"
            verticalMaxHeight="large"
          >
            <DrawerHeader>
              <CatHeading
                className={cx(
                  styles['unable-to-verify-mobile-drawer__header'],
                  'cat-u-theme-typography-title-sm'
                )}
                variant="title-sm"
              >
                {t('CANNOT_VERIFY')}
              </CatHeading>
            </DrawerHeader>
            <DrawerBody
              className={cx(
                styles['unable-to-verify-mobile-drawer__body'],
                'cat-u-theme-typography-body'
              )}
            >
              <p className={styles['unable-to-verify-mobile-drawer__message']}>
                {t(drawerMessage)}
              </p>
              <p>{t(drawerText)}</p>
            </DrawerBody>
          </Drawer>
        )}
      </Portal>
    </>
  );
}
